import { Skeleton, Space } from "antd";
import React from "react";

type SkeletonCapsuleTabsProps = {
  tabsCount?: number;
  centered?: boolean;
};

const SkeletonTabs: React.FC<SkeletonCapsuleTabsProps> = ({
  tabsCount = 4,
  centered = false,
}) => {
  return (
    <Space
      wrap
      style={{
        width: "100%",
        padding: "12px 16px",
        justifyContent: centered ? "center" : "flex-start",
      }}
    >
      {Array.from({ length: tabsCount }).map((_, index) => (
        <Skeleton.Button
          key={index}
          style={{
            width: 80,
            height: 32,
            borderRadius: 32,
          }}
          active
        />
      ))}
    </Space>
  );
};

export default SkeletonTabs;
